import { EllipsisOutlined, FileTextOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Button, Dropdown, Tooltip } from 'antd';

import { DropdownLabel } from '@/shared/components';
import { EFeatureFlags } from '@/shared/consts';
import { checkIsFlagEnabled } from '@/shared/helpers';
import { ETestStatus } from '@/shared/types';

import styles from './OptionsCell.module.scss';

type TProps = {
  openModerateModalCb: VoidFunction;
  participantStatus: ETestStatus;
  resultNotifiedAt: string | null;
  decisionNotifiedAt: string | null;
};

export const OptionsCell = ({
  openModerateModalCb,
  participantStatus,
  resultNotifiedAt,
  decisionNotifiedAt,
}: TProps) => {
  const isReserveFeatureEnable = checkIsFlagEnabled(EFeatureFlags.AdmissionExamReserve);
  const validModerateStatus = isReserveFeatureEnable
    ? [ETestStatus.WaitingForDocuments, ETestStatus.Approved, ETestStatus.Rejected]
    : [ETestStatus.TestPassed, ETestStatus.Approved, ETestStatus.Rejected];
  const tooltipText = isReserveFeatureEnable
    ? `Доступно только для статусов "Ожидание документов", "Одобрено" и "Отклонено" после отправки уведомлений и распределения`
    : `Доступно только для статусов "Тест сдан", "Одобрено" и "Отклонено" после отправки уведомлений о результатах теста`;

  const dropdownItems: MenuProps['items'] = [
    {
      key: 'moderate',
      onClick: openModerateModalCb,
      disabled: !validModerateStatus.includes(participantStatus) || !resultNotifiedAt || !!decisionNotifiedAt,
      label: (
        <Tooltip
          title={
            (!validModerateStatus.includes(participantStatus) || !resultNotifiedAt) && !decisionNotifiedAt
              ? tooltipText
              : null
          }
        >
          <div>
            <FileTextOutlined className={styles['dropdown-icon']} />
            <DropdownLabel text="Модерация" />
          </div>
        </Tooltip>
      ),
    },
  ];

  return (
    <Dropdown
      placement="bottomRight"
      menu={{
        items: dropdownItems,
        onClick: (dropdownItem) => {
          dropdownItem.domEvent.stopPropagation();
        },
      }}
      classNames={{
        root: styles['dropdown-overlay'],
      }}
    >
      <Button
        className={styles['dropdown-button']}
        onClick={(e) => e.stopPropagation()}
      >
        <EllipsisOutlined />
      </Button>
    </Dropdown>
  );
};
